<script setup>
import { ref, computed, defineAsyncComponent, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
/***/
import { useApplicationStore } from '@stores/application';
/***/
import { useAuthUser } from '@compositions/Auth';
/***/
import UserModel from '@models/UserModel';

// Composants
const Layout = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Layouts/Authenticated'));
const RequestHolidaysCounter = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Partial/Dashboard/RemainingHolidays'));
const RequestModal = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Partial/Me/RequestHolidays/RequestHolidaysModal'));
const RequestedList = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Partial/Me/RequestHolidays/List/Wrapper'));

const router = useRouter();
const { t } = useI18n();

const applicationStore = useApplicationStore();

const currentApplication = computed(() => applicationStore.getCurrent);

const { authUser, authUserIsAgent, authUserHasPermission } = useAuthUser({});


const allowed = ref(false);

// Retourne le titre de la page
const pageTitle = (() => {
    const agentType = authUser.value.type === ('EXTERNAL_AGENT') ? 'external' : 'internal';
    const keyMessage = 'page.me.requestedHolidays.:type.title'.replace(':type', agentType);
    return t(keyMessage);
});

// Retourne la description de la page
const pageDescription = (() => {
    const agentType = authUser.value.type === ('EXTERNAL_AGENT') ? 'external' : 'internal';
    const keyMessage = 'page.me.requestedHolidays.:type.description'.replace(':type', agentType);
    return t(keyMessage);
});

onMounted(() => {
    if(! authUserIsAgent.value) {
        router.push({
            name: 'error',
            params: {
                statusCode: 404
            }
        });
    } else {
        allowed.value = true;
        document.title = pageTitle() + ' - ' + currentApplication.value.name;
    }
});

// Retourne si l'utilisateur peut demander un congé
const canRequestHolidays = computed(() => {
    if(! authUser.value) {
        return false;
    }
    return (new UserModel(authUser.value)).canRequestHolidays();
});

const modalRequestOpened = ref(false);
</script>

<template>
    <layout v-if="allowed">
        <div class="content_header">
            <div class="content-header_title">
                <h1 class="first-title">{{ pageTitle() }}</h1>
                <p>{{ pageDescription() }}</p>
            </div>
            <div class="content-header_btn">
                <button
                    v-if="canRequestHolidays"
                    class="button button-primary-outline"
                    @click="modalRequestOpened = true"
                >
                    <span> {{ $t('page.me.requestedHolidays.requestButton.label') }}</span>
                </button>
            </div>
        </div>


        <request-modal
            v-if="modalRequestOpened"
            :user="authUser"
            v-on:close-modal="modalRequestOpened = false"
        ></request-modal>

        <div class="holidays-requested">
            <request-holidays-counter
                :user="authUser"
                :with-request-button="false"
            ></request-holidays-counter>

            <requested-list></requested-list>
        </div>
    </layout>
</template>
